import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

interface DemoTerritory {
  id: string
  name: string
}

export const loadDemoTerritories = createAsyncThunk<
  // Return type of the payload creator
  DemoTerritory[],
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/demoTools/loadDemoTerritories', async (_params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/demoTools/loadDemoTerritories', {
      category: 'rpc',
      type: 'rpc/demoTools/loadDemoTerritories',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result.demoTerritories
  } catch (error) {
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Loading demo territories failed',
      error,
    })
  }
})
